import { useState } from 'react';
import axios from 'axios';
import { parseDoubleEscapedJson } from 'utils/fixDoubleEscapedJSON';

export default function ReferenceCard({ term }) {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [extraData, setExtraData] = useState(null);

  const handleToggle = async () => {
    // Only fetch once, only when expanding
    if (!expanded && !extraData) {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`/edgconnect/term/singleasset/${term.id}`);
        // Match the defensive parsing pattern you already use
        if (typeof response.data === 'string') {
          try {
            const parsed = parseDoubleEscapedJson(response.data);
            console.log('Parsed response data:', parsed);
            setExtraData(parsed.pageItems?.[0] ?? parsed);
          } catch (e) {
            console.error('Failed to parse JSON:', e);
            setError('Failed to load reference data');
          }
        } else {
          setExtraData(response.data);
        }
      } catch (err) {
        console.error('Failed to load reference data:', err);
        setError('Failed to load reference data');
      } finally {
        setLoading(false);
      }
    }

    setExpanded(prev => !prev);
  };

  console.log('term:', term);


  return (
    <div className="bg-white rounded shadow-sm mb-4 p-6">
      {/* Title(s) */}
      <div className="space-y-1 mb-2">
        <h3 className="text-medium-blue text-2xl">
          {term.label}
        </h3>
      </div>

      {/* Expanded content */}
      {expanded && (
        <>
          <dl className="">
            <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Value:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {term.value || ''}
            </dd>
          </div>
            <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Name:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {term.name || ''}
            </dd>
          </div>
          <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Description:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {term.description || ''}
            </dd>
          </div>

          <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Status:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {extraData.pageItems?.status || ''}
            </dd>
          </div>

          <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Last Updated:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {extraData.pageItems?.lastUpdated || ''}
            </dd>
          </div>

          <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Community:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
              {extraData.pageItems?.community.name || ''}
            </dd>
          </div>
          <div className="flex flex-wrap w-full text-sm">
            <dt className="m-0 p-2 font-semibold border-b border-[rgba(44,62,80,.5)] w-one-third">
              Domain:
            </dt>
            <dd className="m-0 p-2 border-b border-[rgba(44,62,80,.5)] w-two-thirds">
                {extraData.pageItems?.domain?.name || ''}
            </dd>
          </div>
        </dl>
        </>
      )}

      {error && <p className="mt-2 text-sm text-high-risk">{error}</p>}
      {loading && <p className="mt-2 text-sm text-muted">Loading...</p>}

      {/* Toggle */}
      <button
        onClick={handleToggle}
        disabled={loading}
        className="p-2 mt-4 text-xs bg-grey-200 disabled--opacity-50"
      >
        {expanded ? 'Show Less' : 'Show More'}
      </button>
    </div>
  );
}
